import Swal from 'sweetalert2'
import { useHistory } from 'react-router-dom'

import AlarmIcon from '../../assets/icons/alarm-exclamation.svg'
import ErrorIcon from '../../assets/icons/error-icon.svg'

export const SoonNews = () => {
  return Swal.fire({
    imageWidth: 72,
    imageHeight: 72,
    iconHtml: `<img src='${AlarmIcon}' />`,
    title: '<span style=\'color: #223A3D; font-size: 24px; font-weight: 700; font-family: "Nunito"; letter-spacing: 0.96px;\'>Em breve, novidades para você!</span>',
    html: '<p style=\'color: #444; font-size: 14px; font-weight: 400; font-family: "Nunito"; margin-bottom: 0px;\'>Estamos desenvolvendo mais uma funcionalidade para melhorar sua experiência. Fique de olho!</p>',
    showCloseButton: true,
    customClass: { container: 'no-circle', confirmButton: 'primaryButton' },
    confirmButtonText: 'Voltar',
    confirmButtonColor: '#01878E'
  })
}

export const RequestErrors = async (url = '/daily') => {
  const history = useHistory()
  return await Swal.fire({
    imageWidth: 72,
    imageHeight: 72,
    iconHtml: `<img src='${ErrorIcon}' />`,
    title: '<span style=\'color: #223A3D; font-size: 24px; font-weight: 700; font-family: "Nunito"; letter-spacing: 0.96px;\'>Erro no carregamento do painel!</span>',
    html: '<p style=\'color: #444; font-size: 14px; font-weight: 400; font-family: "Nunito"; margin-bottom: 0px;\'>Parece que tivemos uma instabilidade no sistema. Por favor, tente acessar o seu painel novamente mais tarde.</p>',
    customClass: { container: 'no-circle', confirmButton: 'primaryButton' },
    confirmButtonText: 'Sair do painel',
    confirmButtonColor: '#01878E'
  }).then((result) => {
    if (result.isConfirmed) {
      history.push(url)
    }
  })
}
export const Generic = async ({ title, subtitle, confirmButton, cancelButton, icon, action }) => {
  return await Swal.fire({
    imageWidth: 96,
    imageHeight: 96,
    iconHtml: `<img src='${icon}' />`,
    title: `<span style='color: #223A3D; font-size: 20px; font-weight: 700; font-family: "Open sans"; line-height: 27.24px;'>${title}</span>`,
    html: `<p style='color: #555; font-size: 14px; font-weight: 400; font-family: "Open sans"; margin-bottom: 0px;'>${subtitle}</p>`,
    customClass: { confirmButton: 'outline', cancelButton: 'primaryButton' },
    confirmButtonText: confirmButton,
    showCancelButton: !!cancelButton,
    cancelButtonText: cancelButton
  }).then((result) => {
    if (action) {
      action(result)
    }
  })
}
